export default [
  // 首页
  {
    path: '/feed',
    name: 'feed',
    meta: {
      title: '首页',
      signOutNoBackFeed: true,
      showSearch:true,
      showFooter: true,
      loginWithoutVerification: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "feed" */
        '@/views/Feed/index'
      ),
  },
];
